import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface RejectMeetingParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class RejectMeetingApiMutation extends ApiMutation<
	void,
	RejectMeetingParams
> {
	client = 'messaging';
	document = gql`
		mutation RejectMeeting($id: UUID!) {
			rejectMeeting(id: $id)
		}
	`;
	method = 'rejectMeeting';
}
